import {Button, message, Modal} from 'antd'
import {course_getCourseById_Api, courseClassSchema,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import {SelectEntityItem} from 'components/SelectEntityItem'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState,} from 'react'
import {BiSolidEdit, BiTrash} from 'react-icons/bi'
import {BsCalendar2Week} from 'react-icons/bs'
import {GoDotFill} from 'react-icons/go'
import {PiListNumbersBold, PiStudentFill} from 'react-icons/pi'
import {RiSubscript} from 'react-icons/ri'
import {Link} from 'react-router-dom'
import {nest, withProps} from 'recompose'
import {ClassActionTypes,} from 'views/AppLocals/Course'
import {FetchClassById} from 'views/AppLocals/Course/components/FetchEntity'
import {CreateCourseClassModal, EditCourseClassModal,} from 'views/AppLocals/Course/CourseClass/CourseClassForm'
import {useCourseClassApi} from 'views/AppLocals/Course/CourseClass/useCourseClassApi'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {NullAsDefault, renderIf} from 'views/Shared'
import {bindingSearch} from 'views/Shared/components/PagerControls'
import {CourseClassStudentList} from '../../../AppLocals/Course/CourseClass/CourseClassStudentForm'
import {CourseClassTimetables} from '../../../AppLocals/Course/CourseClass/CourseClassTimetableForm'
import {HeaderWithIconLine} from '../../../AppLocals/Templates/items/ListHeader'
import copyToClipboard from "copy-to-clipboard";
import {FaUserTie} from "react-icons/fa6";
import CourseClassTeachers from "../../../AppLocals/Course/CourseClass/CourseClassTeachers";
import {IoMdMore} from "react-icons/io";
import {CourseClassProvider} from "../../../AppLocals/Course/CourseClassContext";
import TooltipApp from "components/TooltipApp";
import {IoCopyOutline} from "react-icons/io5";
import {CourseClassSubjectList} from "../../../AppLocals/Course/CourseClass/components/CourseClassSubjectForm";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import LoadingBlock from "../../../LoadingBlock";

export const ListContext = React.createContext(
    {}
)

const renderCourseSubClass = ({actions, renderContextMenu = NullAsDefault} = {}) => (item, index, lastIndex) => {
    const {class_coordinator, number_of_students, course_class_idcode, from_date, to_date} = item ?? {}

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate>
                    {(t) => (
                        <div key={index}
                             style={{color: '#e7e7e7'}}
                             className={classNames("flex flex-wrap items-center gap-2", !lastIndex && 'pb-2 line-border-opacity')}>
                            <div className="flex flex-col">
                                <Link to={getLinkToDetail(item)}
                                      className="font-bold text-sm text-color-000 no-underline">
                                    {getTitle(item)}
                                </Link>
                                <div className="ml-1 flex items-center gap-x-4">
                                    {renderIf(
                                        course_class_idcode,
                                        <div
                                            style={{fontSize: '0.7rem'}}
                                            className="space-x-1 italic cursor-pointer"
                                            onClick={() => {
                                                copyToClipboard(course_class_idcode)
                                                message.info(t('copied'))
                                            }}>
                                            <GoDotFill size={10} className="text-color-500"/>
                                            {renderIf(
                                                !isSm,
                                                <span className="text-color-500 whitespace-no-wrap">
                                                    {`${t('course class idcode')} : `}
                                                </span>
                                            )}
                                            <span
                                                className="font-medium text-blue-500 hover:text-blue-700 tracking-wide">
                                                {course_class_idcode}
                                                <IoCopyOutline size={12} className="ml-1"/>
                                            </span>
                                        </div>
                                    )}
                                    {renderIf(
                                        _.some([from_date, to_date]),
                                        <DoubleValueItem
                                            showIcon={true}
                                            labelFirst={!isSm && "time"}
                                            valueFirst={formatDate(from_date, 'DD/MM/YYYY')}
                                            labelSecond={to_date ? ' - ' : ''}
                                            valueSecond={formatDate(to_date, 'DD/MM/YYYY')}
                                            style={{fontSize: '0.7rem'}}
                                            className="italic"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="flex-1"/>
                            <div className="flex gap-1 justify-end">
                                {actions}
                                {_.isFunction(renderContextMenu) && (renderContextMenu(item))}
                            </div>
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>
    )
}

export const CourseSubClasses = ({item, style, className, owner_id, owner_type}) => {
    const t = useTranslate()

    const {handleAsyncAction = NullAsDefault} = useAsyncAction({
        apiInfo: course_getCourseById_Api,
    })

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onCancel = () => {
        setAction({})
    }

    const course_id = getId(item)

    const fetchCourseOnSuccess = () => {
        onCancel()
        handleAsyncAction({}, {id: course_id})
    }

    const {
        refreshKey,
        onCreate = NullAsDefault,
        onUpdate = NullAsDefault,
        onDelete = NullAsDefault,
    } = useCourseClassApi({
        onUpdated: onCancel,
        onCreated: fetchCourseOnSuccess,
        onDeleted: fetchCourseOnSuccess,
    })

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                title: 'delete class of course',
                message: 'are you sure you want to delete this class of course',
                onOk: () => {
                    onDelete({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const id = getId(params)
        switch (action) {
            case ClassActionTypes.CLASS_CREATE:
            case ClassActionTypes.CLASS_UPDATE:
            case ClassActionTypes.SHOW_TEACHER_LIST_MODAL:
            case ClassActionTypes.SHOW_SUBJECT_LIST_MODAL:
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                setAction({type: action, value: params})
                break
            case ClassActionTypes.CLASS_DELETE:
                confirmDelete(id)
                break
            default:
                break
        }
    }

    const list = useMemo(
        () =>
            Array.from(item?.course_classes ?? []).map((e, index) => {
                const id = getId(e)
                const _lastIndex = item?.course_classes?.length === index + 1

                return (
                    <SelectEntityItem
                        key={index}
                        item={id}
                        defaultItem={e}
                        schema={courseClassSchema}>
                        {(item) => renderIf(
                            item,
                            renderCourseSubClass({
                                actions: [
                                    {
                                        label: 'teacher',
                                        icon: <FaUserTie size={12}/>,
                                        action: ClassActionTypes.SHOW_TEACHER_LIST_MODAL,
                                    },
                                    {
                                        label: 'student',
                                        icon: <PiStudentFill size={12}/>,
                                        action: ClassActionTypes.SHOW_STUDENT_LIST_MODAL,
                                    },
                                    {
                                        label: 'timetables',
                                        icon: <BsCalendar2Week size={12}/>,
                                        action: ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL,
                                    }
                                ].map(({label, action, ...rest}, index) => (
                                    <TooltipApp
                                        key={index}
                                        title={t(label)}
                                        className="text-xs">
                                        <Button
                                            {...rest}
                                            onClick={() => {
                                                handleAction(action, item)
                                            }}
                                            size="small"
                                            className="button-rounded-xs flex flex-center text-color-400"
                                        />
                                    </TooltipApp>
                                )),
                                renderContextMenu: (item) => createContextMenu(
                                    [
                                        {
                                            label: 'subjects',
                                            icon: <RiSubscript size={14} className="text-green-500"/>,
                                            key: ClassActionTypes.SHOW_SUBJECT_LIST_MODAL,
                                        },
                                        {
                                            label: 'edit',
                                            icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                                            key: ClassActionTypes.CLASS_UPDATE,
                                        },
                                        {
                                            label: 'delete',
                                            icon: <BiTrash size={14} className="text-primary-300"/>,
                                            key: ClassActionTypes.CLASS_DELETE,
                                        },
                                    ].filter((e) => e),
                                    (key) => {
                                        handleAction(key, item)
                                    },
                                    {
                                        icon: (
                                            <Button
                                                icon={<IoMdMore size={12}/>}
                                                onClick={() => {
                                                    handleAction(action, item)
                                                }}
                                                size="small"
                                                className="button-rounded-xs flex flex-center text-color-400"
                                            />
                                        )
                                    }
                                ),
                            })(item, index, _lastIndex)
                        )}
                    </SelectEntityItem>
                )
            }),
        [item, refreshKey]
    )

    const modal = useMemo(() => {
        if (!!!action?.type) return null;
        let params = {}
        let modal_params = {}
        let Component = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        const id = getId(action?.value)
        switch (action?.type) {
            case ClassActionTypes.SHOW_TEACHER_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="font-bold text-color-000 tracking-wide">
                                {t('teachers of classes')}
                            </div>
                        }
                        onCancel={onCancel}>
                        <div className="p-3">
                            {bindingSearch({
                                onCancel,
                                owner_id,
                                owner_type,
                                item: action?.value,
                            })(CourseClassTeachers)}
                        </div>
                    </FullSideModalLayout>
                )
            case ClassActionTypes.SHOW_SUBJECT_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="font-bold text-color-000 tracking-wide">
                                {t('subjects of classes')}
                            </div>
                        }
                        onCancel={onCancel}>
                        <div className="p-3">
                            {bindingSearch({
                                onCancel,
                                item: action?.value,
                            })(CourseClassSubjectList)}
                        </div>
                    </FullSideModalLayout>
                )
            case ClassActionTypes.SHOW_STUDENT_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="font-bold text-color-000 tracking-wide">
                                {t('students of class')}
                            </div>
                        }
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            owner_id,
                            owner_type,
                            item: action?.value,
                        })(nest(
                            withProps(({item}) => ({item: getId(item)}))(CourseClassProvider),
                            CourseClassStudentList
                        ))}
                    </FullSideModalLayout>
                )
            case ClassActionTypes.SHOW_TIMETABLE_LIST_MODAL:
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="font-bold text-color-000 tracking-wide">
                                {t('timetable for the class')}
                            </div>
                        }
                        onCancel={onCancel}>
                        {bindingSearch({
                            onCancel,
                            owner_id,
                            owner_type,
                            item: action?.value,
                        })(nest(
                            withProps(({item}) => ({item: getId(item)}))(CourseClassProvider),
                            CourseClassTimetables
                        ))}
                    </FullSideModalLayout>
                )
            case ClassActionTypes.CLASS_CREATE:
                Component = CreateCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('create class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onCreate(values, {id: course_id})
                    },
                }
                break
            case ClassActionTypes.CLASS_UPDATE:
                Wrapper = withProps({id})(FetchClassById)
                Component = EditCourseClassModal
                modal_params = {
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('edit course class')}
                        </div>
                    ),
                }
                params = {
                    container: item,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                break
            default:
                break
        }
        return (
            <Modal
                width={720}
                footer={null}
                onCancel={onCancel}
                open={action?.type}
                destroyOnHidden={true}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Component
                                {...params}
                                {...{item, onCancel, owner_id, owner_type}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [action, owner_id, owner_type])

    return renderIf(
        course_id,
        <div
            style={style}
            className={classNames('flex flex-col gap-2', className)}>
            <HeaderWithIconLine
                icon={<PiListNumbersBold size={14} className="text-color-500 mr-1"/>}
                title="list of classes"
                className="text-sm text-color-400"
                extra={
                    <Button
                        size="small"
                        color="primary" variant="filled"
                        className="button-rounded-md no-border px-3 font-bold text-xs leading-tight italic"
                        onClick={() => {
                            handleAction(ClassActionTypes.CLASS_CREATE)
                        }}>
                        {t('create class')}
                    </Button>
                }
            />
            <div className="flex flex-col gap-2 pl-2 md:pl-3 border-l-2 border-primary">
                {list}
            </div>
            {modal}
        </div>
    )
}





